import React from 'react';
import {connect} from 'react-redux';
import {fetchGroomersForSkiresort} from '../../redux/groomers/actions';
import {fetchUpdates} from '../../redux/updates/actions';
import {changeSelectedDate} from '../../redux/global/actions';
import {Status} from '../../redux/_commons/const';
import ReactSpinner from 'react-spinjs';
import MessagesRow from './MessagesRow';
import moment from 'moment';
import {MONTHS} from '../../config';

import '../../styles/planning.less';


/** Tableau du calendrier */
@connect(
  state => ({
    groomers: state.groomers,
    user: state.user,
    updates: state.updates
  }),
  {fetchGroomersForSkiresort, fetchUpdates, changeSelectedDate}
)
export default class MessagesTable extends React.Component {

  constructor() {
    super();
    this.state = {
      currentSkiresortId: -1,
      timer: null,
      lastUpdate: null,
      shownDate: Date.now()
    };
  }

  load(skiresort, timestamp = +moment.utc()) {
    let {fetchGroomersForSkiresort} = this.props;
    fetchGroomersForSkiresort(skiresort);
    this.setState({
      currentSkiresortId: skiresort.id,
      lastUpdate: timestamp,
      shownDate: this.props.user.selectedDate
    });
  }

  checkForUpdates() {
    if (!this.props.updates.loading) {
      this.props.fetchUpdates(this.props.user.selectedSkiresort);
    }
  }

  componentDidMount() {
    let timeUpdater = () => {
      this.checkForUpdates();
      this.setState({
        timer: setTimeout(timeUpdater, 10000)
      });
    };

    this.load(this.props.user.selectedSkiresort);

    this.setState({
      shownDate: this.props.user.selectedDate,
      timer: setTimeout(timeUpdater, 10000)
    });
  }

  componentWillUnmount() {
    this.setState({
      timer: clearTimeout(this.state.timer)
    });
  }

  componentWillReceiveProps({user, updates}) {
    const currentSkiResort = this.props.user.selectedSkiresort;
    const nextSkiresort = user.selectedSkiresort;
    const lastGroomerChange = updates.content.last_groomer_change ?
      +moment.utc(updates.content.last_groomer_change, 'YYYY-MM-DD HH:mm:SS') : 0;
    if (currentSkiResort.id !== nextSkiresort.id) {
      this.load(nextSkiresort);
    } else if (lastGroomerChange > this.state.lastUpdate) {
      this.load(currentSkiResort, lastGroomerChange);
    }
  }

  previousMonth() {
    const {shownDate} = this.state;

    this.setState({
      shownDate: moment(shownDate).subtract(1, 'month')
    });
  }

  nextMonth() {
    const {shownDate} = this.state;

    this.setState({
      shownDate: moment(shownDate).add(1, 'month')
    });
  }

  render() {
    let {groomers, user, changeSelectedDate} = this.props;
    const {shownDate} = this.state;

    const onDayChanged = day => {
      const m = moment(shownDate);
      changeSelectedDate(+moment([m.year(), m.month(), day]));
    };

    const month = moment(shownDate).month() + 1;
    const year = moment(shownDate).year();

    switch (groomers.status) {
      case Status.LOADING:
        return <ReactSpinner />;
      case Status.FAILURE:
        return <div className="err">Une erreur a eu lieu</div>;
      case Status.OK:
        if (groomers.items.length === 0) {
          return <div className="info">Aucune dameuse pour cette station</div>;
        } else {
          return (
            <div className="planning">
              <div className="title">
                <div className="month-selector">
                  <button type="button"
                          onClick={() => this.previousMonth()}>
                    <i className="mi mi-chevron-left"/>
                  </button>
                  <span>{MONTHS[month - 1]} {year}</span>

                  <button type="button"
                          onClick={() => this.nextMonth()}>
                    <i className="mi mi-chevron-right"/>
                  </button>
                </div>
                {moment(user.selectedDate).isSame(Date.now(), 'day') ? null :
                  <div className="go-today" onClick={() => changeSelectedDate(Date.now()) }>
                    aujourd'hui
                  </div>
                }
                Calendrier : &nbsp; <i>{ moment(user.selectedDate).format('DD/MM/YYYY') }</i>
              </div>
              <DaysRule shown={shownDate} selected={user.selectedDate} onDayChanged={onDayChanged}/>
              <div style={{clear: 'both'}}></div>
              {groomers.items.sortBy(g => (typeof g.code === "string" ? g.code.toLowerCase() : g.code)).valueSeq().toJS().map((g, i)=> <MessagesRow key={g.id} groomer={g} idx={i}
                                                                      shownDate={shownDate}
                                                                      selectedDate={user.selectedDate}/>)}

            </div>
          )
        }
    }

    return null;
  }
}


/** Entete cliquable avec les jours du mois */
let DaysRule = ({shown, selected, onDayChanged}) => {
  let output = [];

  for (let i = 0; i < moment(shown).daysInMonth(); ++i) {
    output.push(
      <div key={i} className={['day', moment(shown).date(i + 1).isSame(selected, 'day') ? 'selected' : null].join(' ')}
           style={{left: `calc(${i * 1.5}vw + ${i * 2}px)`}}>
        <span onClick={ () => onDayChanged(i + 1) }>{i + 1}</span>
      </div>
    );
  }

  return (
    <div className="days">
      {output}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SupportMessages/MessagesTable.js